import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useShouldEducateNewWorker(workerPastShiftsCount: number | undefined) {
  const educateForFirstNBookings = useCbhFlag(CbhFeatureFlag.EDUCATE_FOR_FIRST_N_BOOKINGS, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.EDUCATE_FOR_FIRST_N_BOOKINGS],
  });

  // Only show for shifts 2 through N (not the first shift, which shows Clipboard Score Education)
  const shouldEducateNewWorker =
    workerPastShiftsCount !== undefined &&
    workerPastShiftsCount >= 1 &&
    workerPastShiftsCount < educateForFirstNBookings;

  return {
    shouldEducateNewWorker,
  };
}
